import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CustomAlert from "../AlertComponent/Alert";
import { Global_Data } from "../../globalData/GlobalData";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

const RadioBox = ({ url, data, handleRadio, textValue, freeFormTabbleEditArrays, freeFormTabbleEditMainrecord, formAction }) => {
  const [option, setOption] = useState([]);
  const [customError, setCustomError] = useState("");
  useEffect(() => {
    if (!customError) return;
    CustomAlert("error", customError, { domain: "radio", action: "load-options" });
    setCustomError("");
  }, [customError]);
  const { token, setDefaultTableSelectedDataAwareData } = Global_Data();
  const [value, setValue] = useState("");
  const { loading, trackRequest } = usePendingRequests();

  useEffect(() => {
    const fieldName = data?.component?.sName;
    const editValue = freeFormTabbleEditMainrecord?.[fieldName];
    const hasEditValue =
      editValue !== undefined &&
      editValue !== null &&
      String(editValue) !== "";
    const nextValue =
      formAction === "EDIT" && hasEditValue
        ? String(editValue)
        : data?.component?.sProps?.defaultValue ?? "";

    setValue(currentValue => currentValue === nextValue ? currentValue : nextValue);

    if (textValue?.[fieldName] !== nextValue) {
      handleRadio(nextValue);
    }
  }, [
    formAction,
    freeFormTabbleEditMainrecord,
    data?.component?.sName,
    data?.component?.sProps?.defaultValue
  ]);

  useEffect(() => {
    setDefaultTableSelectedDataAwareData({ [data?.component?.sName]: value });
  }, [value])

  useEffect(() => {
    if (url) {
      trackRequest(() =>
        axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })
      )
        .then(result => {
          setOption(result?.data?.data.records);
        })
        .catch(() => {
          setCustomError("Something went Wrong");
        });
    }
  }, [url]);

  const handleChange = event => {
    setValue(event.target.value);
    handleRadio(event.target.value);
  };

  return (
    <ComponentLoadingBoundary
      loading={loading}
      label={`Loading ${data?.component?.sLabel || data?.component?.sName}`}
      minHeight={40}
      size={20}
    >
      <FormControl>
        <FormLabel
          id="demo-controlled-radio-buttons-group "
          // labelPlacement={data?.component?.sLabel}
        >
          {data?.component?.sLabel}
        </FormLabel>
        <RadioGroup
          {...data?.component?.sProps}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          id={data?.component?.sName}
          value={value}
          onChange={handleChange}
        >
          {option?.length > 0 &&
            option?.map((opt, index) => {
              return (
                <React.Fragment key={index}>
                  <FormControlLabel
                    value={opt?.sValue}
                    control={<Radio {...data?.component?.sProps} />}
                    label={opt?.sChoice}
                    {...data?.component?.sProps}
                    {...data?.component?.options?.others1}
                  />
                </React.Fragment>
              )
            })}
        </RadioGroup>
        <FormHelperText>{data?.component?.sHelper}</FormHelperText>
      </FormControl>
    </ComponentLoadingBoundary>
  );
};

export default RadioBox;
